var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"returns-detailed",attrs:{"data-title":"期权明细"}},[_c('section',[_c('router-view')],1),_c('footer',[_c('earningsTabar',{attrs:{"id":_vm.id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }